import type { CSSProperties } from "react"
import cn from "@/v2-ui/utils/utils.cn"
import Sheet, { type SheetProps } from "@/v2-ui/sheet"
import { useViewSheetResize } from "@/v2-backoffice-client/components/viewSheet/useViewSheetResize"
import ViewSheetResizeHandle from "@/v2-backoffice-client/components/viewSheet/ViewSheetResizeHandle"
import ViewSheetExpandButton from "@/v2-backoffice-client/components/viewSheet/ViewSheetExpandButton"

export type ViewSheetProps = SheetProps & {
  id: string
  className?: string
  /** The width the sheet opens with before the user resizes it. */
  defaultWidth?: number
}

function ViewSheet(props: ViewSheetProps) {
  const { id, className, defaultWidth, children, ...sheetProps } = props
  const { width, isExpanded, onResizeStart, onResetWidth, onToggleExpand } =
    useViewSheetResize(id, defaultWidth)

  return (
    <Sheet modal={false} {...sheetProps}>
      <Sheet.Content
        className={cn("view-sheet", className)}
        style={{ "--view-sheet-width": `${width}px` } as CSSProperties}
        side="right"
        isAnimated={false}
        showOverlay={false}
        closeOnOutsideClick={false}
        renderDefaultCloseButton
      >
        <ViewSheetExpandButton
          isExpanded={isExpanded}
          onClick={onToggleExpand}
        />
        <ViewSheetResizeHandle
          sheetWidth={width}
          onResizeStart={onResizeStart}
          onResetWidth={onResetWidth}
        />
        <div className="view-sheet-inner">{children}</div>
      </Sheet.Content>
    </Sheet>
  )
}

export default ViewSheet
